import React, { useState, useRef, useEffect } from 'react';
import { persianNumberToLatin } from '../../shared/services/general/general-service';

const OTPInput = ({ length, initialValue = '', onComplete }) => {
	const [otp, setOtp] = useState(Array(length).fill(''));
	const [currentIndex, setCurrentIndex] = useState(0);
	const [error, setError] = useState(null);
	const inputs = useRef([]);

	useEffect(() => {
		if (initialValue) {
			const initialOtp = initialValue.split('').slice(0, length);
			setOtp([...initialOtp, ...Array(length - initialOtp.length).fill('')]);
			setCurrentIndex(initialOtp.length); // شاخص را به اولین مقدار خالی تنظیم کنید
		}
	}, [initialValue, length]);

	useEffect(() => {
		if (inputs.current[currentIndex]) {
			inputs.current[currentIndex].focus();
		}
	}, [currentIndex]);

	const handleChange = (value, index) => {
		if (index !== currentIndex) return;

		let input = persianNumberToLatin(value);

		const isValid = /^[0-9]$/.test(input);
		if (!isValid && input !== '') {
			setError('فقط عدد وارد کنید');
			return;
		} else {
			setError(null);
		}

		const newOtp = [...otp];
		newOtp[index] = input.slice(-1);
		setOtp(newOtp);

		if (input && index < length - 1) {
			setCurrentIndex(index + 1);
		}

		if (newOtp.every((char) => char !== '')) {
			validateOtp(newOtp.join(''));
		}
	};

	const handleKeyDown = (e, index) => {
		if (e.key === 'Backspace') {
			const newOtp = [...otp];

			if (otp[index] === '') {
				if (index > 0) {
					setCurrentIndex(index - 1);
					inputs.current[index - 1]?.focus();
				}
			} else {
				newOtp[index] = '';
				setOtp(newOtp);
			}
		}
	};


	const validateOtp = (otpValue) => {
		const isValid = /^[0-9]+$/.test(otpValue) && otpValue.length === length;

		if (isValid) {
			setError(null);
			onComplete(otpValue); // send to parent
		} else {
			setError('کد وارد شده معتبر نیست.');
		}
	};

	return (
		<div dir="ltr">
			<div style={{ display: 'flex', gap: '10px' }}>
				{otp.map((value, index) => (
					<input
						key={index}
						type="text"
						maxLength="1"
						value={value}
						onChange={(e) => handleChange(e.target.value, index)}
						onKeyDown={(e) => handleKeyDown(e, index)}
						ref={(el) => (inputs.current[index] = el)}
						style={{
							width: '45px',
							height: '45px',
							border: 'none',
							fontSize: '14px',
							borderRadius: '8px',
							textAlign: 'center',
							color: 'rgba(0,0,0,.5)',
							borderColor: error ? 'red' : 'black',
							backgroundColor: index === currentIndex ? 'white' : '#eaddff',
							pointerEvents: index === currentIndex ? 'auto' : 'none',
						}}
					/>
				))}
			</div>
			{error && <p style={{ color: 'red', fontSize: '12px',marginTop: '5px',direction: 'rtl', }}>{error}</p>}
		</div>
	);
};

export default OTPInput;
